<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Laporan Laba Rugi</h3>
                        </div>

                        <div class="card-body table-responsive p-2">
                            <div v-for="(records, periode) in data" :key="periode" class="periode-section">
                                <h2 class="periode-title">Periode {{ periode }}</h2>

                                <table class="rekap-table">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Cabang</th>
                                            <th class="text-center">Jumlah Invoice</th>
                                            <th class="text-right">Total Invoice</th>
                                            <th class="text-center">Invoice PAID</th>
                                            <th class="text-right">Nominal PAID</th>
                                            <th class="text-center">Invoice UNPAID</th>
                                            <th class="text-right">Nominal UNPAID</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in records" :key="row.kantor_id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ row.cabang }}</td>
                                            <td class="text-center">{{ row.jml_invoice }}</td>
                                            <td class="text-right">{{ formatCurrency(row.total_invoice) }}</td>
                                            <td class="text-center">{{ row.paid }}</td>
                                            <td class="text-right">{{ formatCurrency(row.total_paid) }}</td>
                                            <td class="text-center">{{ row.unpaid }}</td>
                                            <td class="text-right">{{ formatCurrency(row.total_unpaid) }}</td>
                                        </tr>

                                        <!-- ✅ Tambah baris total per periode -->
                                        <tr class="periode-total">
                                            <td colspan="2" class="text-right font-weight-bold">Total Periode:</td>
                                            <td class="text-center font-weight-bold">
                                                {{ sum(records, 'jml_invoice') }}
                                            </td>
                                            <td class="text-right font-weight-bold">
                                                {{ formatCurrency(sum(records, 'total_invoice')) }}
                                            </td>
                                            <td class="text-center font-weight-bold">
                                                {{ sum(records, 'paid') }}
                                            </td>
                                            <td class="text-right font-weight-bold">
                                                {{ formatCurrency(sum(records, 'total_paid')) }}
                                            </td>
                                            <td class="text-center font-weight-bold">
                                                {{ sum(records, 'unpaid') }}
                                            </td>
                                            <td class="text-right font-weight-bold">
                                                {{ formatCurrency(sum(records, 'total_unpaid')) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "RekapInvoice",
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                const res = await axios.get("/api/laporan/rekap_invoice");
                if (res.data.success) {
                    this.data = res.data.data;
                }
            } catch (error) {
                console.error("Gagal memuat data:", error);
            }
        },
        formatCurrency(value) {
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
            }).format(value || 0);
        },
        // ✅ Fungsi bantu untuk menjumlahkan field tertentu
        sum(records, field) {
            return records.reduce((total, item) => total + (Number(item[field]) || 0), 0);
        },
    },
};
</script>

<style scoped>
.periode-section {
    margin-bottom: 15px;
    padding: 10px;
}

.periode-title {
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 18px;
}

.rekap-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.rekap-table th,
.rekap-table td {
    border: 1px solid #ccc;
    padding: 6px 8px;
    text-align: left;
}

.rekap-table th {
    background-color: #e8f5e9;
    background-color: green;
}

.periode-total td {
    background-color: #f0f0f0;
    font-weight: bold;
}
</style>
